module.exports = __webpack_public_path__ + "static/img/home-over.72110197.png";